import { List, Text } from '@zillow/constellation';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as Checkmark } from '../../images/checkmark.svg';

const StyledCheckmark = styled(Checkmark)`
    flex-shrink: 0;
`;

const StyledListItem = styled(List.Item)`
    display: flex;
    align-items: center;
    padding: 0;
`;

const BulletedCheckList = ({ items, fontType }) => (
    <List appearance="none">
        {items.map(item => (
            <StyledListItem key={item}>
                <StyledCheckmark aria-hidden="true" height={22} width={22} />
                <Text marginLeft="sm" fontType={fontType}>
                    {item}
                </Text>
            </StyledListItem>
        ))}
    </List>
);

BulletedCheckList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string),
    fontType: PropTypes.string,
};

export default BulletedCheckList;
